<script>
import {generateBarChart} from "@/shared/charts/bar-char/bar-chart";
import {debounce} from "lodash";

export default {
  name: "BarChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    colors: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    parentHeight: {
      type: Boolean,
      required: true,
    },
    customGroupSorting: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    chartData: {
      handler: function () {
        this.drawChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart: function () {

     this.$refs. container.firstChild?.remove();
      var width = this.$refs. container.getBoundingClientRect().width ?? 0;
      var height = this.parentHeight
        ? this.$refs. container.parentElement?.getBoundingClientRect().height ?? 0
        : this.config.height;

      // Append the SVG element.
      var node = generateBarChart(this.chartData, this.colors, {
        ...this.config,
        width,
        height,
      }, this.customGroupSorting);
      if (node !== null) {
        this.$refs. container.append(node);
      }
    },
  },
};
</script>

<template>
  <div ref="container" class="horizontal-stacked-bar-chart-svg" />
</template>


<style>
.horizontal-stacked-bar-chart-axis {
  font-style: normal;
  font-weight: normal;
  font-family: Montserrat, sans-serif;

  color: #0a0a0a;
}

.horizontal-stacked-bar-chart-percentage {
  font-family: Montserrat, sans-serif;
  fill: #2f60a6;
}

.bar-chart-tooltip {
  background-color: #ffffff;
  box-shadow: 0 3px 6px #00000029;
  padding: 6px 3px;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  z-index: 9999;
  color: #322c2e;
}

.horizontal-stacked-bar-chart-svg {
  flex-grow: 1;

  svg {
    width: 100%;
  }
}

.grouped-bar-chart-labels {
  /*  font-size: 12px;*/
  line-height: 15px;
  font-family: Montserrat, sans-serif;

  fill: #2f60a6;
  opacity: 1;
}
.x-axis-labels {
  font-family: Montserrat, sans-serif;
  color: #605e5f;
  opacity: 1;
}

.bar-chart-top-labels,
.bar-chart-bottom-labels {
  text-align: center;
  font-family: Montserrat, sans-serif;
  fill: #2f60a6;
}
.horizontal-stacked-bar-chart-svg {
  flex-grow: 1;

  svg {
    width: 100%;
  }
}
</style>
